<template>
  <div :class="boxMsgStyle">
    <v-container class="pa-0 mt-2 mb-2" fluid>
      <v-row no-gutters>
        <v-spacer v-if="isUserSend"></v-spacer>
        <v-col xs="6" sm="4" md="3" lg="2" xl="1">
          <!-- <div class="image-box-content">
            <div class="image-display">
              <v-img :src="msgFileUrl" aspect-ratio="1.333" cover />
            </div>
          </div> -->
          <v-hover>
            <template v-slot:default="{ hover }">
              <div style="position: relative;">
                <div class="image-box-content">
                  <div class="image-display">
                    <!-- <v-img :src="msgFileUrl" aspect-ratio="1.333" cover /> -->
                    <v-icon size="170">mdi-file-document-outline</v-icon>
                  </div>
                </div>
                <v-fade-transition>
                  <v-overlay
                    v-if="hover"
                    absolute
                    color="#411C0B"
                  >
                    <div style="width: 100%; height: 100%; cursor: pointer; text-align: center;" @click="downloadFile">
                      <v-icon size="70">mdi-download</v-icon><br/>
                      filename.jpg
                    </div>
                  </v-overlay>
                </v-fade-transition>
              </div>
              
            </template>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
    <iframe id="frm_download" style="display:none;"></iframe>
  </div>
</template>

<script>
import handlerMessage from "../../business/handler_messages"
import handlerData from "../../business/handler_data"
import $ from "jquery"
export default {
  name: 'ChatDownloadBox',
  props: {
    isFirstMsg: false, // to display style
    isLastMsg: false, // to display style
    isUserSend: false, // to display style
    content: null, // content, button
  },
  data() {
    return {
      msgFileUrl: '',
    }
  },
  mounted() {
    try {
      // console.log(this.content);
      this.msgFileUrl = this.content.url
      
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    downloadFile() {
      // $("#frm_download")[0].src = this.msgFileUrl;
      // $.ajax({url: this.msgFileUrl});

      fetch(this.msgFileUrl)
      .then(resp => resp.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = 'abc.jpg';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        alert('your file has downloaded!'); // or you know, something with better UX...
      })
      .catch(() => alert('oh no!'));
    }
  },
  computed: {
    boxMsgStyle() {
      let st = "box-msg"
      if (this.isFirstMsg) {
        st = st + " first-box-msg"
      }
      if (this.isLastMsg) {
        st = st + " last-box-msg"
      }
      return st
    },
    msgContentStyle() {
      let st = ""
      if (this.isUserSend) {
        st = "msg-2"
      } else {
        st = "msg-1"
      }

      if (this.isLastMsg) {
        st = st + " " + st + "-lst-msg"
      }
      return st
    }
  }
}
</script>

<style lang="scss" scoped>
  .image-display {
    border: 1px solid lightgray;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
  }
</style>